import { device } from 'src/styles/breakpoints'
import { orange, white } from 'src/styles/colors'
import styled from 'styled-components'

export const Section = styled.section`
  background-color: #29292b;

  h2 {
    font-family: 'Citrina', Helvetica, sans-serif;
    font-weight: 700;

    @media ${device.desktopXXL} {
      font-size: 50px;
    }

    span {
      color: ${orange.base};
    }
  }

  h3 {
    font-family: 'Citrina', Helvetica, sans-serif;
  }

  .subtitle {
    margin-bottom: 75px;
    font-weight: 400;
  }
`

export const BoxCard = styled.div`
  background-color: rgba(104, 104, 104, 0.2);
  padding: 18.76px 20.31px;
  height: 210px;
  width: 100%;
  border-radius: 12px;

  @media ${device.tablet} {
    height: 210px;
  }
  @media ${device.desktopLG} {
    padding-left: 20.32px;
    padding-right: 20.32px;
  }
  @media ${device.desktopXL} {
    padding: 32.12px 24.56px;
    height: 260px;
  }

  h3 {
    margin-top: 15px;
    margin-bottom: 15px;

    @media ${device.desktopXXL} {
      font-size: 22px;
      line-height: 27px;
    }
  }

  p {
    @media ${device.desktopXXL} {
      font-size: 16px;
    }
  }
`
export const Button = styled.button`
  background-color: ${orange.base};
  color: ${white};
  padding: 10px 20px;
  border-radius: 8px;
  cursor: pointer;
  margin-top: 24px;
  height: 48px;
  width: 270px;
  font-size: 14px;
  font-weight: 700;
`
